module.exports = __webpack_public_path__ + "img/thumbnail_SussexChicken_f_normal.159d6374.png";